import fetchHandler from "./Handler";

export const ChapterGET = async (endpoint) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};

export const ChapterPOST = async (data) => {
  try {
    const response = await fetchHandler({
      method: "POST",
      endpoint: "chapters",
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const ChapterPUT = async (id, data) => {
  try {
    const response = await fetchHandler({
      method: "PUT",
      endpoint: `chapters/${id}`,
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const ChapterPagePUT = async (id, data) => {
  try {
    const response = await fetchHandler({
      method: "PUT",
      endpoint: `pages/${id}`,
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};

//  chapter innner pages

export const ChapterinnerGET = async (endpoint) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const ChapterinnerPageGET = async (endpoint) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: endpoint,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};

// pages
export const PagesPOST = async (data, id) => {
  try {
    const response = await fetchHandler({
      method: "POST",
      endpoint: `pages/${id}`,
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const PagesGETSingle = async (endpoint) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const PagesPUTSingle = async (id, data) => {
  try {
    const response = await fetchHandler({
      method: "PUT",
      endpoint: `pages/${id}`,
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const pagesComments = async (endpoint) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
export const ChaptercommentsPOST = async (endpoint, data) => {
  try {
    const response = await fetchHandler({
      method: "POST",
      endpoint,
      data,
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};